import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "productImageAlt",
})
export class ProductImageAltPipe implements PipeTransform {
  transform(imageURL: string): string {
    // https://pics.vwgroup.se/prod/TOP/large/Krets_Drager_12069.jpg => Krets Drager 12069
    const pieces = imageURL.split("/");
    const imageName = pieces[pieces.length - 1];

    return imageName.split(".")[0].replace(/_/g, " ");
  }
}
